import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { SvgIconComponent } from '../../shared/components/svg-icon/svg-icon.component';

import { ISvgConfig } from '../../shared/interfaces/svg.interfaces';

import { ESvgTypes } from '../../shared/enums/svg.enums';
import { EPromptUsage } from '../../shared/enums/shared.enums';

@Component({
  selector: 'stxt-suggested-prompt',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './suggested-prompt.component.html',
  styleUrl: './suggested-prompt.component.scss'
})
export class SuggestedPromptComponent implements OnChanges {
  @Input() suggestedPrompt: string;
  @Input() userInput!: string;
  @Input() usageCase: EPromptUsage;
  public sendIcon: ISvgConfig = { name: 'interactive', fill: ESvgTypes.None };
  public highlightedPrompt!: SafeHtml;
  protected readonly EPromptUsage = EPromptUsage;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    this.highlightedPrompt = this.getHighlightedText(this.suggestedPrompt, this.userInput);
  }

  private getHighlightedText(text: string, input: string): SafeHtml {
    if (!text) return '';

    const showMe = 'Show me';
    const hasShowMe = text.toLowerCase().startsWith(showMe.toLowerCase());

    // Handle "Show me" highlighting first
    let prefix = '';
    let rest = text;

    if (hasShowMe) {
      prefix = text.substring(0, showMe.length);
      rest = text.substring(showMe.length);
    }

    // Escape HTML in both parts
    const safePrefix = hasShowMe ? this.escapeHtml(prefix) : '';
    let safeRest = this.escapeHtml(rest);

    // Handle input highlighting in the rest part if present
    if (input?.trim()) {
      const searchText = input.trim();
      const regex = new RegExp(this.escapeRegex(searchText), 'gi');
      safeRest = safeRest.replace(regex, '<strong class="highlight">$&</strong>');
    }

    // Combine the parts
    const result = hasShowMe
      ? `<strong class="highlight">${safePrefix}</strong>${safeRest}`
      : safeRest;

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  private escapeHtml(text: string): string {
    if (!text) return '';
    const htmlEscapes: { [key: string]: string } = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    return text.replace(/[&<>"']/g, char => htmlEscapes[char]);
  }

  private escapeRegex(input: string): string {
    if (!input) return '';
    return input.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
}
